import { render } from "./Loader.vue?vue&type=template&id=3dafb78d&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=3dafb78d&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dafb78d"]])

export default __exports__